<template>
  <v-card color="background" height="100%" style="border-radius: 0px; position: relative;">
    <!--
        <div class="search-bar" v-if="searchOpen" >
            <input type="text" placeholder="Pesquisar" @blur="toggleSearch" class="search-bar-border">

            <v-btn text color="#2b4093" v-bind="attrs" v-on="on" class="search-button">
                Pesquisar
            </v-btn>
        </div>
        -->

    <v-container fluid class="limiter-content header-content">
      <div class="card-header-content">
          <v-row no-gutters>
            <v-col class="px-3 px-lg-0">
              <div class="social-icons limiter-content">
                <a href="https://www.facebook.com/brizolaejapur/" target="_blank">
                  <v-icon class="social-icon-item" color="secondary">mdi-facebook</v-icon>
                </a>
                <a class="social-icon-item" href="https://instagram.com/brizolajapur?utm_medium=copy_link"
                  target="_blank">
                  <v-icon color="secondary">mdi-instagram</v-icon>
                </a>

                <a class="social-icon-item" href="https://www.linkedin.com/company/brizola-e-japur" target="_blank">
                  <v-icon color="secondary">mdi-linkedin</v-icon>
                </a>

                <v-btn class="px-0" v-if="!user" text @click="dialogAccess = true" color="primary">
                  <v-icon class="mr-2" size="22" color="secondary">mdi-lock</v-icon>
                  Cadastre-se / Login
                </v-btn>

                <v-menu v-else min-width="200" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on">
                      <v-icon class="mr-2" color="secondary">mdi-account</v-icon>
                      {{ user ? 'Olá, ' + normalizeName(user.name) : ' Cadastre-se / Login' }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item link :to="null" color="primary" @click.native="logout">
                      <v-list-item-icon>
                        <v-icon>mdi-logout</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title>Sair</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <!-- <v-btn text @click="dialogAccess = true" color="primary">
                                <v-icon class="mr-2">mdi-account</v-icon>
                                {{ 'Olá, ' + normalizeName(user.name) }}
                            </v-btn> -->

                <!--
    <v-icon color="primary" style="margin-right: 20px;" @click="toggleSearch">mdi-magnify</v-icon>
    -->

              </div>
            </v-col>
          </v-row>

          <v-row>
            <!-- <v-spacer></v-spacer> -->
            <v-col>
              <div class="d-flex align-center px-3 px-lg-0">
                <v-row justify="space-between" align="center">
                  <v-col>
                    <div @click="goToHome">
                      <img src="@/assets/logo-bej.svg" width="120px" class="mr-8 mt-1" />
                    </div>
                  </v-col>

                  <div class="px-4 hidden-lg-and-up">
                    <v-col class="mx-2">
                      <v-btn icon color="black" @click="toogleMenuApp">
                        <v-icon size="40">mdi-menu</v-icon>
                        <span class="font-weight-bold ml-4">MENU</span>
                      </v-btn>
                    </v-col>
                  </div>
                </v-row>

                <div></div>

                <v-row justify="space-between" class="hidden-md-and-down">
                  <div v-for="(item, index) in sidebarMenu" :key="index">
                    <template v-if="!item.children || item.children.length === 0">
                      <v-btn text :to="item.route" class="menu-item">
                        {{ item.name }}
                      </v-btn>
                    </template>
                  </div>
                  <v-menu v-model="creditorAreaMenu" offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn text color="#2c4093" v-bind="attrs" v-on="on" class="ml-2 menu-buttons">
                        <span class="v-btn__content">
                          CASOS / EMPRESAS
                          <span class="v-btn__content--inside">
                            <v-icon right>mdi-chevron-down</v-icon>
                          </span>
                        </span>
                      </v-btn>
                    </template>
                    <v-list class="dropdown-menu-list">
                      <v-list-item v-for="(item, index) in dropDownCasesCompanies" :key="index" :to="item.route" link
                        class="submenu-item">
                        <v-btn text :to="item.route" class="text-white-on-hover">
                          {{ item.name }}
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-badge
                        :value="showRunningVotingBanner"
                        color="error"
                        dot
                        overlap
                        offset-x="10"
                        offset-y="2">
                        <v-btn text color="#2c4093" v-bind="attrs" v-on="on" class="menu-buttons"
                          style="margin-left: 10px;">
                          <span class="v-btn__content">
                            {{ creditorAreaTitle }}
                            <span class="v-btn__content--inside">
                              <v-icon right>mdi-chevron-down</v-icon>
                            </span>
                          </span>
                        </v-btn>
                      </v-badge>
                    </template>

	                    <v-list class="dropdown-menu-list">
	                      <template v-for="(item, index) in currentCreditorAreaItemsWithVoting">
	                        <div
	                          v-if="item.isRunningVotingGroup"
	                          :key="`running-voting-${index}`"
	                          class="submenu-item running-voting-group">
	                          <v-list-item link @click.stop="toggleRunningVotingSubmenu">
	                            <v-list-item-icon class="mr-3">
	                              <v-icon small color="secondary">mdi-vote-outline</v-icon>
	                            </v-list-item-icon>
	                            <v-list-item-content>
	                              <v-list-item-title class="text-white-on-hover">
	                                {{ item.name }}
	                              </v-list-item-title>
	                            </v-list-item-content>
	                            <v-list-item-action>
	                              <v-icon color="secondary">
	                                {{ runningVotingSubmenuOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
	                              </v-icon>
	                            </v-list-item-action>
	                          </v-list-item>

	                          <template v-if="runningVotingSubmenuOpen">
	                            <v-list-item
	                              v-for="(votingItem, votingIndex) in item.children"
	                              :key="`running-voting-child-${votingIndex}`"
	                              link
	                              class="submenu-item running-voting-child"
	                              @click="goToRunningVoting(votingItem)">
	                              <v-list-item-content>
	                                <v-list-item-title class="text-white-on-hover">
	                                  {{ votingItem.name }}
	                                </v-list-item-title>
	                              </v-list-item-content>
	                            </v-list-item>
	                          </template>
	                        </div>

	                        <!-- Grupo com sub-itens (ex.: Assembleia de Credores) -->
	                        <div
	                          v-else-if="item.children"
	                          :key="`creditor-area-group-${index}`"
	                          class="submenu-item menu-group">
	                          <v-list-item link @click.stop="toggleMenuGroup(item.name)">
	                            <v-list-item-content>
	                              <v-list-item-title class="text-white-on-hover">
	                                {{ item.name }}
	                              </v-list-item-title>
	                            </v-list-item-content>
	                            <v-list-item-action>
	                              <v-icon color="secondary">
	                                {{ isMenuGroupOpen(item.name) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
	                              </v-icon>
	                            </v-list-item-action>
	                          </v-list-item>

	                          <template v-if="isMenuGroupOpen(item.name)">
	                            <v-list-item
	                              v-for="(child, childIndex) in item.children"
	                              :key="`creditor-area-group-child-${childIndex}`"
	                              :to="child.route"
	                              link
	                              class="submenu-item menu-group-child"
	                              @click="closeCreditorAreaMenu">
	                              <v-btn text :to="child.route" class="text-white-on-hover">
	                                {{ child.name }}
	                              </v-btn>
	                            </v-list-item>
	                          </template>
	                        </div>

	                        <v-list-item
	                          v-else
	                          :key="`creditor-area-${index}`"
	                          :to="item.route || undefined"
	                          :href="item.href || undefined"
	                          :target="item.href ? '_blank' : undefined"
	                          :rel="item.href ? 'noopener noreferrer' : undefined"
	                          link
	                          class="submenu-item"
	                          @click="closeCreditorAreaMenu">
	                          <v-btn
	                            text
	                            :to="item.route || undefined"
	                            :href="item.href || undefined"
	                            :target="item.href ? '_blank' : undefined"
	                            :rel="item.href ? 'noopener noreferrer' : undefined"
	                            class="text-white-on-hover">
	                            {{ item.name }}
	                          </v-btn>
	                        </v-list-item>
	                      </template>
	                    </v-list>
                  </v-menu>


                </v-row>

                <!--
        <v-btn text color="#2b4093" class="menu-buttons" style="margin-left: 10px;" to="/assembleia-credores">
            ASSEMBLEIA DE CREDORES
        </v-btn>


        <v-btn text color="#2b4093" class="menu-buttons" style="margin-left: 10px;" to="/solicitacao-ppp">
            SOLICITAÇÃO DE PPP
        </v-btn>
        -->

                <v-menu v-if="user" min-width="200" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <!-- <div class="logged-user d-none d-sm-flex ml-4">
                    <span class="logged-user-name font-weight-bold">{{ user.name }}</span>
                    <span class="logged-user-email">{{ user.email }}</span>
                </div> -->
                    <!--
                                    <v-btn text v-bind="attrs" v-on="on">
                                        <v-icon class="mr-2">mdi-account</v-icon>
                                        {{ user ? 'Olá, ' + normalizeName(user.name) : ' Cadastre-se / Login' }}
                                    </v-btn> -->
                  </template>
                  <v-list>
                    <v-list-item link :to="null" color="primary" @click.native="logout">
                      <v-list-item-icon>
                        <v-icon>mdi-logout</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title>Sair</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-col>
            <!-- <v-spacer></v-spacer> -->
          </v-row>
        </div>

      <!-- MENU MOBILE -->
      <v-row class="hidden-lg-and-up" v-if="menuApp" @clickaway="closeMenuApp">
        <v-col cols="12" justify="space-between" align="end">
          <v-col cols="12">
            <div class="py-2" v-for="(item, index) in sidebarMenu" :key="index">
              <template v-if="!item.children || item.children.length === 0">
                <v-btn @click="toogleMenuApp" text :to="item.route" class="menu-item">
                  {{ item.name }}
                </v-btn>
              </template>
            </div>
          </v-col>

          <v-col cols="12" class="py-2">
            <v-menu v-model="mobileCreditorAreaMenu" offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-badge
                  :value="showRunningVotingBanner"
                  color="error"
                  dot
                  overlap
                  offset-x="10"
                  offset-y="2">
                  <v-btn text color="#2c4093" v-bind="attrs" v-on="on" class="menu-buttons" style="margin-left: 10px;">
                    <span class="v-btn__content">
                      {{ creditorAreaTitle }}
                      <span class="v-btn__content--inside">
                        <v-icon right>mdi-chevron-down</v-icon>
                      </span>
                    </span>
                  </v-btn>
                </v-badge>
              </template>

	              <v-list class="dropdown-menu-list">
	                <template v-for="(item, index) in currentCreditorAreaItemsWithVoting">
	                  <div
	                    v-if="item.isRunningVotingGroup"
	                    :key="`mobile-running-voting-${index}`"
	                    class="submenu-item running-voting-group">
	                    <v-list-item link @click.stop="toggleRunningVotingSubmenu">
	                      <v-list-item-icon class="mr-3">
	                        <v-icon small color="secondary">mdi-vote-outline</v-icon>
	                      </v-list-item-icon>
	                      <v-list-item-content>
	                        <v-list-item-title class="text-white-on-hover">
	                          {{ item.name }}
	                        </v-list-item-title>
	                      </v-list-item-content>
	                      <v-list-item-action>
	                        <v-icon color="secondary">
	                          {{ runningVotingSubmenuOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
	                        </v-icon>
	                      </v-list-item-action>
	                    </v-list-item>

	                    <template v-if="runningVotingSubmenuOpen">
	                      <v-list-item
	                        v-for="(votingItem, votingIndex) in item.children"
	                        :key="`mobile-running-voting-child-${votingIndex}`"
	                        link
	                        class="submenu-item running-voting-child"
	                        @click="goToRunningVoting(votingItem, true)">
	                        <v-list-item-content>
	                          <v-list-item-title class="text-white-on-hover">
	                            {{ votingItem.name }}
	                          </v-list-item-title>
	                        </v-list-item-content>
	                      </v-list-item>
	                    </template>
	                  </div>

	                        <!-- Grupo com sub-itens (ex.: Assembleia de Credores) -->
	                        <div
	                          v-else-if="item.children"
	                          :key="`mobile-creditor-area-group-${index}`"
	                          class="submenu-item menu-group">
	                          <v-list-item link @click.stop="toggleMenuGroup(item.name)">
	                            <v-list-item-content>
	                              <v-list-item-title class="text-white-on-hover">
	                                {{ item.name }}
	                              </v-list-item-title>
	                            </v-list-item-content>
	                            <v-list-item-action>
	                              <v-icon color="secondary">
	                                {{ isMenuGroupOpen(item.name) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
	                              </v-icon>
	                            </v-list-item-action>
	                          </v-list-item>

	                          <template v-if="isMenuGroupOpen(item.name)">
	                            <v-list-item
	                              v-for="(child, childIndex) in item.children"
	                              :key="`mobile-creditor-area-group-child-${childIndex}`"
	                              :to="child.route"
	                              link
	                              class="submenu-item menu-group-child"
	                              @click="closeCreditorAreaMenu">
	                              <v-btn text :to="child.route" class="text-white-on-hover" @click="toogleMenuApp()">
	                                {{ child.name }}
	                              </v-btn>
	                            </v-list-item>
	                          </template>
	                        </div>

	                  <v-list-item
	                    v-else
	                    :key="`mobile-creditor-area-${index}`"
	                    :to="item.route || undefined"
	                    :href="item.href || undefined"
	                    :target="item.href ? '_blank' : undefined"
	                    :rel="item.href ? 'noopener noreferrer' : undefined"
	                    link
	                    class="submenu-item"
	                    @click="closeCreditorAreaMenu">
	                    <v-btn
	                      @click="toogleMenuApp()"
	                      text
	                      :to="item.route || undefined"
	                      :href="item.href || undefined"
	                      :target="item.href ? '_blank' : undefined"
	                      :rel="item.href ? 'noopener noreferrer' : undefined"
	                      class="text-white-on-hover">
	                      {{ item.name }}
	                    </v-btn>
	                  </v-list-item>
	                </template>
	              </v-list>
            </v-menu>
          </v-col>

          <v-col cols="12" class=" py-2">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text color="#2c4093" v-bind="attrs" v-on="on" class="ml-2 menu-buttons">
                  <span class="v-btn__content">
                    CASOS / EMPRESAS
                    <span class="v-btn__content--inside">
                      <v-icon right>mdi-chevron-down</v-icon>
                    </span>
                  </span>
                </v-btn>
              </template>
              <v-list class="dropdown-menu-list">
                <v-list-item v-for="(item, index) in dropDownCasesCompanies" :key="index" :to="item.route" link
                  class="submenu-item">
                  <v-btn @click="toogleMenuApp" text :to="item.route" class="text-white-on-hover">
                    {{ item.name }}
                  </v-btn>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-col>
      </v-row>
    </v-container>

    <!-- <v-app-bar app dark color="transparent" clipped-left flat style="position: relative;">
            <v-app-bar-nav-icon color="primary" @click="drawer = true" class="d-flex d-md-none"></v-app-bar-nav-icon> -->

    <v-spacer></v-spacer>

    <!-- </v-app-bar> -->

    <v-navigation-drawer v-model="drawer" absolute temporary color="primary">
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item v-if="user" class="mt-10">
            <v-list-item-content>
              <v-list-item-title><span class="white--text"><v-icon class="mr-2 white--text">mdi-account</v-icon>
                  {{ 'Olá, ' + normalizeName(user.name) }}</span></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-for="(item, index) in sidebarMenu" :key="index" link :to="item.route" color="white">
            <v-list-item-content>
              <v-list-item-title><span class="white--text">{{ item.name }}</span></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="!user" class="mt-10" @click="dialogAccess = true">
            <v-list-item-content>
              <v-list-item-title><span class="white--text">
                  <v-icon class="mr-2 white--text">mdi-account</v-icon> Cadastre-se / Login</span></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-else class="mt-10" @click="logout">
            <v-list-item-content>
              <v-list-item-title><span class="white--text">
                  <v-icon class="mr-2 white--text">mdi-logout</v-icon> Sair</span></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-dialog persistent v-model="dialogRegister" :width="600">
      <register-component></register-component>
    </v-dialog>

    <v-dialog v-model="dialogForgotPassword" :width="600">
      <forgot-password-component></forgot-password-component>
    </v-dialog>

    <v-dialog v-model="dialogAccess" :width="600">
      <access-component></access-component>
    </v-dialog>

    <progress-bar></progress-bar>

    <div v-if="visibleRunningZoomMeetings.length" class="running-agc-banner-wrap">
      <div
        v-for="item in visibleRunningZoomMeetings"
        :key="`running-agc-banner-${item.id}`"
        class="running-agc-banner">
        <button type="button" class="reminder-close" title="Fechar" @click="dismissRunningMeetingBanner(item)">
          <v-icon small color="#fff">mdi-close</v-icon>
        </button>
        <div class="running-agc-banner-content">
          <div class="running-agc-banner-text">
            <strong>AGC em andamento</strong>
            <div>{{ formatRunningMeetingName(item) }}</div>
          </div>
          <v-btn
            color="secondary"
            class="running-agc-banner-button"
            :loading="runningZoomLoadingId === item.id"
            @click="joinRunningZoomMeeting(item)">
            <v-icon left small>mdi-video-outline</v-icon>
            Entrar na reunião
          </v-btn>
        </div>
      </div>
    </div>

    <div v-if="visibleRunningVotingNotices.length" class="running-voting-notice-stack">
      <div
        v-for="(voting, index) in visibleRunningVotingNotices"
        :key="`running-voting-notice-${voting.id}`"
        class="running-voting-notice">
        <button type="button" class="reminder-close" title="Fechar" @click="dismissRunningVotingNotice(voting)">
          <v-icon small color="#fff">mdi-close</v-icon>
        </button>
        <div class="running-voting-notice-content">
          <div class="running-voting-notice-text">
            <strong>{{ voting.voted ? 'Você já votou' : 'Votação em andamento' }}</strong>
            <div>{{ runningVotingNoticeText(voting, index) }}</div>
          </div>
          <div class="running-voting-notice-actions">
            <v-btn color="secondary" class="running-voting-notice-button" @click="goToRunningVoting(voting)">
              {{ voting.voted ? 'Ver meu voto' : 'Votar agora' }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <div v-if="breadcrumbItems.length" class="breadcrumb-div" style="margin-top: 16px;">
      <v-breadcrumbs style="color: #FF5733 !important" class="custom-breadcrumbs limiter-content"
        :items="breadcrumbItems">
        <template v-slot:divider>
          <span class="mediumWhite--text">/</span>
        </template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item :disabled="item.disabled">
            <span style="letter-spacing: 0.15em !important;" class="mediumWhite--text">
              {{ item.text }}
            </span>
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>

    <v-container v-if="!verifyIgnoredRouter" class="limiter-content">
      <router-view></router-view>
    </v-container>

    <template v-else>
      <router-view></router-view>
    </template>

    <!-- Pop-up de documentos em atraso do credor/procurador logado (confirmacao vai para a auditoria).
         O usuario do site guarda so nome e tipo (sem id): o criterio de login e o mesmo da votacao. -->
    <overdue-notice-dialog v-if="user" />
  </v-card>
</template>

<script>
// import userApi from "@/common/api/user.api";
import { eventHub } from '@/main';

import router from '../router';
import axios from 'axios';

import ProgressBar from '@/components/layout/ProgressBar.vue';
import OverdueNoticeDialog from '@/components/OverdueNoticeDialog.vue';
import Register from '@/views/user/Register.vue';
import Access from '@/views/user/Access.vue';
import ForgotPassword from "@/views/user/ForgotPassword.vue";

import sidebarMenu from '@/common/data/sidebar-menu.data';
import breadcrumbs from '@/common/data/breadcrumbs.data';
import { creditorItems, procuratorItems } from '@/common/data/creditor-area.data';
import dropDownCasesCompanies from '@/common/data/cases-companies.data';

export default {
  name: 'PrivateLayout',

  components: {
    'progress-bar': ProgressBar,
    'register-component': Register,
    'access-component': Access,
    'forgot-password-component': ForgotPassword,
    'overdue-notice-dialog': OverdueNoticeDialog
  },

  data() {
    return {
      user: null,
      logoUrl: null,
      menuGroups: [],
      drawer: false,
      menuApp: false,
      dialogRegister: false,
      dialogAccess: false,
      dialogForgotPassword: false,
      searchTerm: null,
      displaySettingsMenu: false,
      sidebarMenu: sidebarMenu,
      dropDownCreditorArea: creditorItems,
      procuratorAreaItems: procuratorItems,
      dropDownCasesCompanies: dropDownCasesCompanies,
      searchOpen: false,
      creditorAreaMenu: false,
      mobileCreditorAreaMenu: false,
      runningVotingSubmenuOpen: false,
      // Grupos do menu da area do credor abertos (ex.: Assembleia de Credores).
      openMenuGroups: [],
      breadcrumbs: breadcrumbs,
      breadcrumbItems: [],
      defaultBreadcrumb: { text: 'Brizola e Japur', href: '/#/home' },
      currentRoute: null,
      ignoreStyleRoutes: ['team', 'home'],
      runningVotings: [],
      runningVotingIntervalId: null,
      loadingRunningVoting: false,
      dismissedRunningVotingNoticeIds: [],
      dismissedRunningMeetingIds: [],
      runningGeneralMeetings: [],
      loadingRunningGeneralMeetings: false,
      runningZoomLoadingId: null
    };
  },

  created() {
    this.restoreDismissedReminders();
    this.user = this.$root.user;

    eventHub.$on('DIALOG-REGISTER', value => {
      this.dialogRegister = value;
    });

    eventHub.$on("DIALOG-FORGOT-PASSWORD", (value) => {
      this.dialogForgotPassword = value;
    });

    eventHub.$on('DIALOG-ACCESS', value => {
      this.dialogAccess = value;
    });

    this.$ga.enable();

    eventHub.$on('logout', () => {
      this.logout();
    });

    this.setActionButtons();

    this.normalizeBreadcrumb(this.$route);
    this.loadRunningVoting();
    this.loadRunningGeneralMeetings();
    this.startRunningVotingWatcher();
  },

  destroyed() {
    eventHub.$off('THEME_UPDATED');
    this.stopRunningVotingWatcher();
  },

  watch: {
    $route(to, from) {
      this.normalizeBreadcrumb(to);
      this.loadRunningVoting();
    }
  },

  computed: {
    isProcurator() {
      return !!this.user && Number(this.user.type) === 2;
    },
    creditorAreaTitle() {
      return this.isProcurator ? 'ÁREA DO PROCURADOR' : 'ÁREA DO CREDOR';
    },
    currentCreditorAreaItems() {
      return this.isProcurator ? this.procuratorAreaItems : this.dropDownCreditorArea;
    },
	    currentCreditorAreaItemsWithVoting() {
	      const items = [...this.currentCreditorAreaItems];

	      if (!this.showRunningVotingBanner) return items;

	      const votingItems = this.runningVotings.map((voting, index) => ({
	        name: this.formatRunningVotingName(voting, index),
	        route: `/assembleia-credores/votacao/${voting.id}`,
	        isRunningVoting: true
	      }));

	      return [
	        {
	          name: `Votações em andamento (${this.runningVotings.length})`,
	          isRunningVotingGroup: true,
	          children: votingItems
	        },
	        ...items
	      ];
	    },
    showRunningVotingBanner() {
	      return !!this.user && this.runningVotings.length > 0;
	    },
      visibleRunningVotingNotices() {
        return this.runningVotings.filter((voting) => !this.isRunningVotingDismissed(voting));
      },
      runningZoomMeetings() {
        if (!this.user || this.isProcurator) return [];

        return this.runningGeneralMeetings.filter((item) => this.canJoinRunningZoomMeeting(item));
      },
      visibleRunningZoomMeetings() {
        return this.runningZoomMeetings.filter((item) => !this.dismissedRunningMeetingIds.includes(String(item.id)));
      }
	  },

  methods: {
    startRunningVotingWatcher() {
      if (!this.user || this.runningVotingIntervalId) return;

      this.runningVotingIntervalId = setInterval(() => {
        this.loadRunningVoting();
        this.loadRunningGeneralMeetings();
      }, 30000);
    },

    stopRunningVotingWatcher() {
      if (!this.runningVotingIntervalId) return;

      clearInterval(this.runningVotingIntervalId);
      this.runningVotingIntervalId = null;
    },

    async loadRunningVoting() {
      if (!this.user || this.loadingRunningVoting) return;

      this.loadingRunningVoting = true;

      try {
	        const result = await axios.get('/api/general-meeting-votings');
	        const runningVotings = result.data.content && Array.isArray(result.data.content.data)
	          ? result.data.content.data
	          : [];

	        this.runningVotings = runningVotings;
	      } catch (error) {
	        this.runningVotings = [];
	      } finally {
	        this.loadingRunningVoting = false;
	      }
	    },

      async loadRunningGeneralMeetings() {
        if (!this.user || this.isProcurator || this.loadingRunningGeneralMeetings) return;

        this.loadingRunningGeneralMeetings = true;

        try {
          const result = await axios.get('/api/general-meetings/next');
          const meetings = result.data.content && Array.isArray(result.data.content.data)
            ? result.data.content.data
            : [];

          this.runningGeneralMeetings = meetings.filter((item) => Number(item.status) === 5);
        } catch (error) {
          this.runningGeneralMeetings = [];
        } finally {
          this.loadingRunningGeneralMeetings = false;
        }
      },

	    formatRunningVotingName(voting, index) {
	      const votingName = voting && voting.name ? voting.name : `Votação ${index + 1}`;
	      const meetingName = voting && voting.general_meeting_name ? voting.general_meeting_name : null;
	      const label = meetingName ? `${meetingName} / ${votingName}` : votingName;

	      return this.truncateMenuText(label, 42);
	    },

	    truncateMenuText(value, maxLength) {
	      const text = String(value || '');
	      return text.length > maxLength ? `${text.slice(0, maxLength - 3)}...` : text;
	    },

      getRunningVotingKey(item) {
        return item && item.id ? String(item.id) : null;
      },

      isRunningVotingDismissed(item) {
        const key = this.getRunningVotingKey(item);
        return key ? this.dismissedRunningVotingNoticeIds.includes(key) : false;
      },

      runningVotingNoticeText(item, index = 0) {
        if (!item) return '';
        const label = this.formatRunningVotingName(item, index);
        if (item.voted) return `${label}. Seu voto está registrado. Você pode revisar ou restaurar o voto enquanto a votação estiver aberta.`;
        if (item.voted_partial) return `${label}. Você votou em parte das classes; faltam ${item.credits - item.voted_credits}.`;
        return `${label}. Acesse para registrar seu voto enquanto a votação estiver aberta.`;
      },

      dismissRunningVotingNotice(item) {
        const key = this.getRunningVotingKey(item);
        if (key && !this.dismissedRunningVotingNoticeIds.includes(key)) {
          this.dismissedRunningVotingNoticeIds = [...this.dismissedRunningVotingNoticeIds, key];
          this.persistDismissedReminders();
        }
      },

      dismissRunningMeetingBanner(item) {
        const key = item && item.id ? String(item.id) : null;
        if (key && !this.dismissedRunningMeetingIds.includes(key)) {
          this.dismissedRunningMeetingIds = [...this.dismissedRunningMeetingIds, key];
          this.persistDismissedReminders();
        }
      },

      // Lembretes fechados ficam fechados enquanto a aba estiver aberta.
      persistDismissedReminders() {
        try {
          sessionStorage.setItem('dismissed-reminders', JSON.stringify({
            votings: this.dismissedRunningVotingNoticeIds,
            meetings: this.dismissedRunningMeetingIds,
          }));
        } catch (error) { /* armazenamento indisponivel: so nao persiste */ }
      },

      restoreDismissedReminders() {
        try {
          const saved = JSON.parse(sessionStorage.getItem('dismissed-reminders') || '{}');
          if (Array.isArray(saved.votings)) this.dismissedRunningVotingNoticeIds = saved.votings.map(String);
          if (Array.isArray(saved.meetings)) this.dismissedRunningMeetingIds = saved.meetings.map(String);
        } catch (error) { /* ignora */ }
      },

      closeCreditorAreaMenu() {
        this.creditorAreaMenu = false;
        this.mobileCreditorAreaMenu = false;
        this.runningVotingSubmenuOpen = false;
        this.openMenuGroups = [];
      },

      isMenuGroupOpen(name) {
        return this.openMenuGroups.includes(name);
      },

      toggleMenuGroup(name) {
        this.openMenuGroups = this.isMenuGroupOpen(name)
          ? this.openMenuGroups.filter((item) => item !== name)
          : [...this.openMenuGroups, name];
      },

      toggleRunningVotingSubmenu() {
        this.runningVotingSubmenuOpen = !this.runningVotingSubmenuOpen;
      },

      canJoinRunningZoomMeeting(item) {
        if (!item || !item.zoom_enabled) return false;
        return !!item.has_accreditation && [1, 2].includes(Number(item.status_accreditation));
      },

      formatRunningMeetingName(item) {
        if (!item) return 'Assembleia';

        const clientName = item.client_name || (item.client && item.client.name ? item.client.name : '');
        return [clientName, item.name].filter(Boolean).join(' - ') || 'Assembleia';
      },

      async joinRunningZoomMeeting(item) {
        if (!item) return;

        this.runningZoomLoadingId = item.id;

        try {
          const result = await axios.post(`/api/general-meetings/${item.id}/zoom/join`);
          const joinUrl = result.data.content && result.data.content.join_url;

          if (!joinUrl) {
            this.$dialog.notify.error('Link individual da reunião não disponível.', { position: 'top-right', timeout: 5000 });
            return;
          }

          window.open(joinUrl, '_blank', 'noopener,noreferrer');
        } catch (error) {
          this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
        } finally {
          this.runningZoomLoadingId = null;
        }
      },

	    goToRunningVoting(item, closeMobileMenu = false) {
	      if (!item) return;
	      if (closeMobileMenu) this.toogleMenuApp();
        this.closeCreditorAreaMenu();

        const route = item.route || `/assembleia-credores/votacao/${item.id}`;
	      this.$router.push(route).catch(() => {});
	    },

    normalizeBreadcrumb(route) {
      const findedBreadcrumb = this.breadcrumbs.find(
        x => x.key.toLowerCase() === route.name.toLowerCase()
      );

      if (!findedBreadcrumb) {
        this.breadcrumbItems = [];
        return;
      }

      this.breadcrumbItems = [this.defaultBreadcrumb, ...findedBreadcrumb.breadcrumb];
    },

    setActionButtons() {
      // Grupo
    },
    //toggleSearch() {
    //    this.searchOpen = !this.searchOpen;
    //},

    // closeMenu() {
    //     this.$refs.menu.save()
    // },

    menuActionClick(event) {
      event.preventDefault();
    },

    goToHome() {
      this.$router.replace('/').catch(() => { });
    },

    normalizeName(name) {
      if (typeof name !== 'string' || !name) {
        return '';
      }

      const splitName = name.split(' ');
      return splitName.length > 1 ? splitName[0] : name;
    },

    verifyIgnoredRouter() {
      const findedBreadcrumb = this.ignoreStyleRoutes.find(
        x => x.toLowerCase() === this.$route.name.toLowerCase()
      );

      return !!findedBreadcrumb;
    },

    async logout() {
      // if (await this.$root.$confirm(true, "user.logout")) {
      //     userApi.clearcurrentUser;
      //     this.$router.push({ name: "Login" });
      // }

      localStorage.clear();
      this.stopRunningVotingWatcher();
      router.go('/home');
    },

    toogleMenuApp() {
      this.menuApp = !this.menuApp;
    },

    closeMenuApp() {
      this.meuApp = false;
    }
  }
};
</script>

<style scoped lang="scss">
.title {
  color: var(--v-primary-base) !important;
  // color: #2b4093 !important;
  text-decoration: none;
}

.menu-bar {
  color: #2b4093 !important;
}

.text-button {
  font-size: 10px;
}

/*
.menu-button-container {
   // background-color: var(--v-secondary-base) !important;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 80px;
    text-align: center;
}

.menu-button {
    margin: auto;
    bottom: 0;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
}
*/

.logged-user {
  text-align: left;
  margin-right: 10px;
  font-size: 13px;
  font-weight: 400;
  flex-direction: column;

  &-name {
    display: block;
  }

  &-email {
    display: block;
  }
}

.menu-item-default {
  color: #2b4093;
}

.menu-item-hover {
  color: #009986;
}

.header-content {
  background: var(--v-mediumWhite-base);
  width: 100% !important;
  min-width: 100% !important;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: -16px;
  margin-top: -16px;
  padding-bottom: 20px;
  padding-top: 20px;
}

.card-header-content {
  margin-left: auto;
  margin-right: auto;
  width: 82% !important;
  max-width: 1120px !important;
  background-color: rgba(255, 255, 255, 0) !important;
}

/*
.menu-subheader {
    padding-left: 16px;
    color: var(--v-primary-base);
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.001px;
}

.menu-title {
    padding-left: 16px;
    color: var(--v-important-base);
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
}
*/
/*
.casos-submenu-item {
    color: white !important;
    background-color: #2b4093 !important;
    padding-left: 16px;
    border-bottom: 1px solid #009986;
    font-family: Raleway,sans-serif !important;
    font-size: 12px !important;
    font-style: normal;
    line-height: 24px;
    transition: color 0.3s;
}
.casos-submenu-item:hover {
    color: green !important;
}
*/

.menu-item {
  color: #180032 !important;
  // padding-left: 20px;
  // padding-right: 20px;
  // width: 100% !important;
  background-color: transparent !important;
  font-family: 'Raleway';
  font-size: 12px;
  font-style: normal;
  // line-height: 24px;
  transition: color 0.3s;
}

.menu-item:hover {
  color: #7877e5 !important;
}

.submenu-item {
  color: white !important;
  background-color: #180032 !important;
  // padding-left: 16px;
  border-bottom: 1px solid #7877e5;
  font-family: Raleway, sans-serif;
  font-size: 12px;
  font-style: normal;
  line-height: 24px;
  transition: color 0.3s;
}

/* Sub-itens de um grupo do menu: recuados, em fonte menor */
.menu-group-child .v-btn {
  padding-left: 28px !important;
  font-size: 11px !important;
}

.submenu-item:hover {
  color: var(--v-secondary-base) !important;
}

.menu-buttons {
  color: white !important;
  background-color: #180032 !important;
  font-family: 'Raleway', sans-serif;
  font-size: 12px;
  font-style: normal;
  transition: color 0.3s;
  border-radius: 10px;
}

.menu-buttons:hover {
  color: #f1ece2 !important;
  background-color: #180032 !important;
}

.text-white-on-hover {
  color: white !important;
}

.text-white-on-hover:hover {
  color: var(--v-secondary-base) !important;
}

.hover-green:hover {
  color: green;
}

.social-icons {
  position: relative;
  margin-right: auto;
  margin-right: -24px !important;
  padding-top: 20px;
  // margin-right: 200px;
  // display: flex;
  text-align: right;
  background: transparent;
  // right: 100px;
}

.v-breadcrumbs {
  padding-left: 0 !important;
}

.breadcrumb-div {
  background-color: var(--v-primary-base);

  a .v-breadcrumbs__item {
    color: #FF5733 !important;
  }
}

.v-breadcrumbs .v-breadcrumbs__item {
  color: #FF5733;
  /* Cor personalizada */
}

.social-icons a {
  margin-right: 20px;
  text-decoration: none;
  color: inherit;
}

.dropdown-menu-list {
  // background-color: var(--v-primary-base) !important;
  padding: 0px;
}

.running-agc-banner-wrap {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: min(360px, calc(100vw - 48px));
  z-index: 230;
  pointer-events: none;
}

.running-agc-banner {
  background: #180032;
  border-radius: 8px;
  box-shadow: 0 14px 34px rgba(24, 0, 50, 0.26);
  color: #fff;
  margin-top: 12px;
  padding: 18px;
  pointer-events: auto;
}

.running-agc-banner-content {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 14px;
  width: 100%;
}

.running-agc-banner-text {
  min-width: 0;
  font-family: Raleway, sans-serif;
  font-size: 14px;
  line-height: 1.35;
}

.running-agc-banner-text strong {
  display: block;
  font-size: 15px;
  margin-bottom: 4px;
}

.running-agc-banner-button {
  align-self: flex-start;
}

.running-voting-notice-stack {
  position: fixed;
  right: 24px;
  bottom: 180px;
  z-index: 220;
  width: min(360px, calc(100vw - 48px));
  pointer-events: none;
}

.running-voting-notice {
  background: #180032;
  border-left: 4px solid #7877e5;
  border-radius: 8px;
  box-shadow: 0 14px 34px rgba(24, 0, 50, 0.26);
  color: #fff;
  margin-top: 12px;
  padding: 18px;
  pointer-events: auto;
}

.running-voting-notice-content {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 14px;
  width: 100%;
}

.running-voting-notice-text {
  min-width: 0;
  font-family: Raleway, sans-serif;
  font-size: 14px;
  line-height: 1.35;
}

.running-voting-notice-text strong {
  display: block;
  font-size: 15px;
  margin-bottom: 4px;
}

.running-voting-notice-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.running-voting-notice-button {
  flex: 1;
}

@media (max-width: 600px) {
  .running-agc-banner-wrap {
    right: 12px;
    bottom: 12px;
    width: calc(100vw - 24px);
  }

  .running-agc-banner-button {
    width: 100%;
  }

  .running-voting-notice-stack {
    right: 12px;
    bottom: 132px;
    width: calc(100vw - 24px);
  }

  .running-voting-notice-button {
    width: 100%;
  }
}

.running-agc-banner,
.running-voting-notice {
  position: relative;
  padding-right: 40px;
}

.reminder-close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 0;
  background: rgba(255, 255, 255, 0.14);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
}

.reminder-close:hover {
  background: rgba(255, 255, 255, 0.3);
}
</style>
